import React, { useState, useEffect } from "react";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import {
  Table,
  Pagination,
  Grid,
  Loader,
  Checkbox
} from "semantic-ui-react";
import { Container, Content, Center, Input } from './styled'
import { pb4y as api, pb4yLocal as local } from "../../../../services/apis";
import { datePattern } from '../../../../utils/Utils';
import { Box } from "@material-ui/core";

function ContasExcluidas() {
  const [userList, setUserList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [dateStart, setDateStart] = useState('');
  const [dateEnd, setDateEnd] = useState('');
  const [loading, setLoading] = useState(false);
  const [feedback, setFeedback] = useState(false);

  useEffect(() => {
    async function getDate() {
      setLoading(true)
      const searchFilter = search ? `&search=${search}` : '';
      const feedbackFilter = feedback ? `&feedback=true` : '';
      const searchDate = formatDate(dateStart, dateEnd);

      await api.get(`user-delete?page=${page}${searchFilter}${searchDate}${feedbackFilter}`).then(res => {
        console.log(res.data.items);
        setUserList(res.data.items);
        setTotalPages(res.data.pages);
        setTotalItems(res.data.totalItems);
        setLoading(false)
      }).catch(err => {
        setLoading(false)
        console.error(err);
      })
    }
    getDate()
  }, [page, search, dateStart, dateEnd, feedback])

  const formatDate = (start, end) => {
    if (!start || !end) return '';
    return `&dateStart=${start}&dateEnd=${end}`;
  }

  return (
    <Box width="100%" paddingLeft="250px">
    <Box width="100%" padding="1rem">
      <AdminMenu />
        <Content>
          <h1>Contas Excluídas</h1>
          <h3>Total de Contas excluídas: {totalItems}</h3>

          <Grid stackable columns={2}>
            <Grid.Row>
              <Grid.Column>
                <Center>
                  <Input
                    type="search"
                    placeholder="Digite o Id ou email do usuário"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </Center>
              </Grid.Column>

              <Grid.Column>
                <Center>
                  Somente com feedback&nbsp;
                  <Checkbox toggle value={feedback} onClick={() => setFeedback(!feedback)} />
                </Center>
              </Grid.Column>
            </Grid.Row>

            <Grid.Column>
              <Center>
                <div className="ui fluid" style={{ width: "50%" }}>
                  <strong>De:</strong>
                  <div className="ui input fluid">
                    <input
                      type="date"
                      onChange={(e) => setDateStart(e.target.value)}
                      value={dateStart}
                    />
                  </div>
                </div>
                <div className="ui fluid"
                  style={{ marginLeft: "16px", width: "50%" }}
                >
                  <strong>Até:</strong>
                  <div className="ui input fluid">
                    <input
                      type="date"
                      onChange={(e) => setDateEnd(e.target.value)}
                      value={dateEnd}
                    />
                  </div>
                </div>
              </Center>
            </Grid.Column>
            <Grid.Column>
              <Center>
                <Pagination
                  boundaryRange={0}
                  activePage={page}
                  defaultActivePage={1}
                  onPageChange={(e, f) => setPage(f.activePage)}
                  firstItem={null}
                  lastItem={null}
                  totalPages={totalPages}
                />
              </Center>
            </Grid.Column>
          </Grid>

          <Table stackable>
            <Table.Header>
              <Table.HeaderCell style={{ width: "5%" }}>
                <Center>ID</Center>
              </Table.HeaderCell>
              <Table.HeaderCell style={{ width: "15%" }}>
                <Center>ID Usuário</Center>
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>E-mail</Center>
              </Table.HeaderCell>
              <Table.HeaderCell style={{ width: '40%' }} >
                <Center>Motivo</Center >
              </Table.HeaderCell>
              <Table.HeaderCell>
                <Center>Data da exclusão</Center>
              </Table.HeaderCell>
            </Table.Header>

            {loading ? <Loader active={loading} /> :
              userList.length !== 0 ? userList.map(user => {

                return (
                  <Table.Body>
                    <Table.Row>
                      <Table.Cell style={{ width: "5%" }}>
                        <Center>{user.id}</Center>
                      </Table.Cell>
                      <Table.Cell style={{ width: "15%" }}>
                        <Center>{user.id_user}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{user.email}</Center>
                      </Table.Cell>
                      <Table.Cell style={{ width: '40%' }}>
                        <Center style={{ justifyContent: 'start' }}>{user.motivo}</Center>
                      </Table.Cell>
                      <Table.Cell>
                        <Center>{datePattern(user.data_delete)}</Center>
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>)
              }) : <Table.Footer>
                <Table.Row>
                  <Table.HeaderCell colSpan='7'>
                    <Center>Nenhuma conta encontrada</Center>
                  </Table.HeaderCell>
                </Table.Row>
              </Table.Footer>}

          </Table>
        </Content>
      </Box>
    </Box>
  )
}

export default ContasExcluidas;
